module.exports = __webpack_public_path__ + "static/media/heroGraphic1800.00496e35.png";